package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class ForgotPasswordResponse(
    @SerialName("message") val message: String
)